function header() {
	const siteHeader = document.querySelector('header.header');
	if (!siteHeader) return;

	window.addEventListener('scroll', function () {
		if (window.scrollY > 1) {
			siteHeader.classList.add('scrolled')
		} else {
			siteHeader.classList.remove('scrolled')
		}
	})
}